// App.jsx
import React, { Component } from 'react';

import '../css/App.css';
import Hero from './Hero';
import ScrollIndicator from './ScrollIndicator';
import Skills from './Skills';
import Header from './Header';
import Footer from './Footer';
import Projects from './Projects';


class App extends Component {
  componentDidMount() {
    document.documentElement.style.scrollBehavior = 'smooth';
    document.body.style.scrollBehavior = 'smooth';

    window.scrollTo = new Proxy(window.scrollTo, {
      apply(target, thisArg, args) {
        target.apply(thisArg, [...args, { behavior: 'smooth' }]);
      },
    });
  }

  render() {
    return (
        <>
              <Header />
              <ScrollIndicator />
              <Hero />
              <Projects />
              <Skills />
              <Footer />
            </>

    );
  }
}

export default App;
